import Bowser from 'bowser';

const MIN_IPAD_TOUCH_POINTS = 2;

const getPlatformType = () => {
  const { userAgent } = window.navigator;

  const parser = Bowser.getParser(userAgent);
  const userAgentPlatform = parser.getPlatformType();

  const isIpad = userAgent.includes('Macintosh') && window.navigator.maxTouchPoints > MIN_IPAD_TOUCH_POINTS;

  return isIpad ? 'tablet' : userAgentPlatform;
};

export default function getDeviceType(): 'desktop' | 'mobile' {
  const platform = getPlatformType();

  return platform === 'mobile' || platform === 'tablet' ? 'mobile' : 'desktop';
}
